import { createApiClient, getCurrentTenant } from "@eduviaos/shared";

/**
 * Singleton API client for this portal. The `onUnauthorized` callback is
 * wired up post-construction by the AuthProvider so a stale-cookie 401
 * round-trip can flush the in-memory access token and redirect to login.
 *
 * `tenantSlugProvider` is read on EVERY request so the same SPA can sit
 * on different subdomains (`acme.eduviaos.app`, `dehradun.eduviaos.app`)
 * without re-instantiation — the BE scopes everything from the
 * `X-Tenant-Slug` header that this provider feeds in.
 */
export const api = createApiClient({
  baseURL: import.meta.env.VITE_API_URL,
  tenantSlugProvider: () => getCurrentTenant().slug,
});
